export default __webpack_public_path__ + "static/media/graphQuery.ec56fd1f.svg";